import { Subscription } from 'rxjs';

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation
} from '@angular/core';

import { DeviceService, IconSizeEnum, ISliderInfo, SdThemeComponent, SizesEnum } from '@seb/web-design-system/core';
import { IRecipeCard, SdRecipeCardComponent } from '@seb/web-design-system/recipe-card';
import { SdShowMoreComponent } from '@seb/web-design-system/show-more';

@Component({
  selector: 'sd-recipe-list',
  templateUrl: './recipe-list.component.html',
  styleUrls: ['./recipe-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdShowMoreComponent,
    SdRecipeCardComponent
  ]
})
export class SdRecipeListComponent extends SdThemeComponent implements OnInit, OnDestroy {
  @Input()
  isLazyLoading = false;

  @Input()
  recipes: IRecipeCard[];

  @Input()
  totalCount: number;

  @Input()
  showSize = 1;

  @Input()
  showedRow = 1;

  @Input()
  twicPicsAutoSize = true;

  @Input()
  isLoading = false;

  /**
   * Emitted when the view more btn is clicked
   */
  @Output()
  viewMore = new EventEmitter<ISliderInfo>();

  @Output()
  recipeClicked = new EventEmitter<IRecipeCard>();

  iconSize = IconSizeEnum;
  sizesEnum = SizesEnum;
  subscriptions = new Subscription();
  isMobile$: boolean;

  constructor(
    private deviceService: DeviceService,
    protected cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.deviceService.isMobile.subscribe((x) => {
        this.isMobile$ = x;
        this.cdRef.markForCheck();
      })
    );
  }

  onRecipeClicked(recipe: IRecipeCard): void {
    this.recipeClicked.emit(recipe);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
